/* Pro-Witgoed — Levertijd renderer (multi-location aware)
 *
 * Leest data-attributes op .pw-levertijd-wrapper en bepaalt de juiste tekst:
 *   data-stock-denbosch  = voorraad op Den Bosch (uit variant metafield)
 *   data-stock-nod       = voorraad op NOD (uit variant metafield)
 *   data-handling-override = optionele leadtime-override per variant
 *   data-available       = is variant active in Shopify (back-compat)
 *
 * Flows (priority):
 *   1. Den Bosch > 0  → pickup/leverdag-model, identiek aan de PDP (pws-delivery-countdown.js):
 *                       vóór cutoff op een pickup-dag (ma-vr, geen feestdag) → levering =
 *                       eerstvolgende leverdag (meestal "Morgen in huis"); anders → pickup =
 *                       volgende pickup-dag, levering = eerstvolgende leverdag daarna.
 *   2. NOD > 0        → "Uiterlijk vrijdag X bezorgd" (handling-override of default 8 werkdagen)
 *   3. Available zonder voorraad → backorder NOD-flow
 *   4. Niet available → "Tijdelijk uitverkocht"
 *
 * Back-compat: oude wrappers met alleen data-stock blijven werken (data-stock="true"
 * wordt geïnterpreteerd als Den Bosch voorraad).
 */
(function () {
  if (typeof window.pwDeliveryScriptLoaded !== 'undefined') {
    if (typeof window.pwCalculateDeliveryDates === 'function') {
      window.pwCalculateDeliveryDates();
    }
    return;
  }
  window.pwDeliveryScriptLoaded = true;
  window.pwCountdownInterval = null;

  // Config — wordt door theme.liquid uit shop-metafields gerendered in window.pwsConfig.
  // Wijzigen in beheer → Voorraad-sync → Shopify → NOD-location → leadtime werkt direct door.
  var CFG = (typeof window !== 'undefined' && window.pwsConfig) || {};
  var CUTOFF_HOUR = typeof CFG.cutoffHour === 'number' ? CFG.cutoffHour : 17;
  var CUTOFF_MINUTE = typeof CFG.cutoffMinute === 'number' ? CFG.cutoffMinute : 0;
  // 20-10-2026 koerier 21:00 (Sander): de koerier (alles zonder de tag pakket-bezorging) heeft een eigen grens.
  // CUTOFF_HOUR/MINUTE hierboven blijven de DPD-grens. Een kaart zonder data-dpd krijgt de DPD-grens (de vroegste).
  var CUTOFF_HOUR_KOERIER = typeof CFG.cutoffHourKoerier === 'number' ? CFG.cutoffHourKoerier : 21;
  var CUTOFF_MINUTE_KOERIER = typeof CFG.cutoffMinuteKoerier === 'number' ? CFG.cutoffMinuteKoerier : 0;
  function grensVoor(el) {
    return el.getAttribute('data-dpd') === 'false' ? [CUTOFF_HOUR_KOERIER, CUTOFF_MINUTE_KOERIER] : [CUTOFF_HOUR, CUTOFF_MINUTE];
  }
  var NOD_DEFAULT_LEAD_DAYS = typeof CFG.backorderDays === 'number' ? CFG.backorderDays : 8;
  var HOLIDAYS = [
    // 2026
    '2026-01-01', '2026-04-03', '2026-04-05', '2026-04-06', '2026-04-27',
    '2026-05-05', '2026-05-14', '2026-05-24', '2026-05-25',
    '2026-12-25', '2026-12-26',
    // 2027
    '2027-01-01', '2027-03-26', '2027-03-28', '2027-03-29', '2027-04-27',
    '2027-05-06', '2027-05-16', '2027-05-17',
    '2027-12-25', '2027-12-26'
  ];

  function clearCountdown() {
    if (window.pwCountdownInterval) {
      clearInterval(window.pwCountdownInterval);
      window.pwCountdownInterval = null;
    }
  }

  function startCountdown() {
    clearCountdown();
    function tick() {
      var nowNL = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
      // Per kaart de eigen grens (data-cutoff-h/m, gezet in calculate); de klok stopt pas als geen kaart meer telt.
      var nogActief = false;
      document.querySelectorAll('.pw-levertijd-countdown').forEach(function (span) {
        var cutoff = new Date(nowNL);
        cutoff.setHours(parseInt(span.dataset.cutoffH || CUTOFF_HOUR, 10), parseInt(span.dataset.cutoffM || CUTOFF_MINUTE, 10), 0, 0);
        var diff = cutoff - nowNL;
        if (diff > 0 && span.dataset.active === 'true') {
          nogActief = true;
          var h = String(Math.floor(diff / 3600000)).padStart(2, '0');
          var m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
          var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
          span.textContent = LT_TEKST ? LT_TEKST.binnen.replace('{t}', h + ':' + m + ':' + s) : 'bestel binnen ' + h + ':' + m + ':' + s;
          span.style.display = 'inline';
        } else {
          span.style.display = 'none';
          span.dataset.active = 'false';
        }
      });
      if (!nogActief) clearCountdown();
    }
    tick();
    window.pwCountdownInterval = setInterval(tick, 1000);
  }

  function fmtDateKey(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + dd;
  }

  // Leverdag: ma t/m za, geen zondag, geen NL-feestdag.
  // (Zaterdag = leverdag bij PW; alleen pakketdienst-pickup zou wel ma-vr zijn,
  //  maar voor leadtime-rekening tellen we leverdagen.)
  function isWorkDay(d) {
    var day = d.getDay();
    if (day === 0) return false;
    return HOLIDAYS.indexOf(fmtDateKey(d)) === -1;
  }

  // Pickup-dag: ma t/m vr, geen feestdag — de dagen dat een bestelling op pad
  // gaat. Zelfde definitie als isPickupDay in pws-delivery-countdown.js (PDP).
  function isPickupDay(d) {
    var day = d.getDay();
    if (day === 0 || day === 6) return false;
    return HOLIDAYS.indexOf(fmtDateKey(d)) === -1;
  }

  // Eerstvolgende dag ná start waarvoor pred true is.
  function nextDayWhere(start, pred) {
    var d = new Date(start);
    d.setDate(d.getDate() + 1);
    while (!pred(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function addWorkDays(start, n) {
    var d = new Date(start);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isWorkDay(d)) added++;
    }
    return d;
  }

  var dayNames = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];

  // 19-10-2026: TEKST PER TAAL. Op /fr-be/ en /en/ stond "Woensdag 21 oktober bezorgd" en "Tijdelijk uitverkocht".
  // De datum komt nu uit Intl in de taal van de pagina, net als op de productpagina (pws-delivery-countdown.js,
  // 12-10). Voor het Nederlands is de uitkomst letterlijk dezelfde; valt Intl weg, dan blijft het oude Nederlands.
  var LT_TAAL = (document.documentElement.getAttribute('lang') || 'nl').slice(0, 2).toLowerCase();
  var LT_LOCALE = { nl: 'nl-NL', fr: 'fr-BE', de: 'de-DE', en: 'en-GB' }[LT_TAAL] || 'nl-NL';
  var LT_TEKST = {
    nl: { morgen: 'Morgen in huis', op: '{d} bezorgd', uiterlijk: 'Uiterlijk {d} bezorgd', uit: 'Tijdelijk uitverkocht', binnen: 'bestel binnen {t}' },
    fr: { morgen: 'Livré demain', op: 'Livré le {d}', uiterlijk: 'Livré au plus tard le {d}', uit: 'Temporairement épuisé', binnen: 'commandez dans {t}' },
    en: { morgen: 'Delivered tomorrow', op: 'Delivered {d}', uiterlijk: 'Delivered by {d}', uit: 'Temporarily sold out', binnen: 'order within {t}' },
    de: { morgen: 'Morgen geliefert', op: 'Lieferung am {d}', uiterlijk: 'Lieferung spätestens am {d}', uit: 'Vorübergehend ausverkauft', binnen: 'bestellen Sie innerhalb von {t}' }
  }[LT_TAAL] || null;
  function ltTekst(sleutel, datum) {
    var t = (LT_TEKST || {})[sleutel];
    if (!t) return null;
    if (datum) {
      var s = null;
      try { s = new Intl.DateTimeFormat(LT_LOCALE, { weekday: 'long', day: 'numeric', month: 'long' }).format(datum); } catch (e) { s = null; }
      if (!s) return null;
      if (t.indexOf('{d}') === 0) s = s.charAt(0).toUpperCase() + s.slice(1);
      t = t.replace('{d}', s);
    }
    return t;
  }

  function fmtNL(date) {
    return date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' });
  }

  function calculate() {
    var nowNL = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    var hasActiveCountdown = false;

    document.querySelectorAll('.pw-levertijd-wrapper:not(.processed)').forEach(function (el) {
      var stockDB = parseInt(el.getAttribute('data-stock-denbosch') || '0', 10);
      var stockNOD = parseInt(el.getAttribute('data-stock-nod') || '0', 10);
      var handlingOverride = parseInt(el.getAttribute('data-handling-override') || '0', 10);
      var isAvailable = el.getAttribute('data-available') === 'true';
      var textEl = el.querySelector('.pw-levertijd-tekst');
      var countdownEl = el.querySelector('.pw-levertijd-countdown');

      if (!textEl) {
        el.classList.add('processed');
        return;
      }

      // Back-compat: oude wrappers met alleen data-stock="true|false"
      if (!el.hasAttribute('data-stock-denbosch') && el.hasAttribute('data-stock')) {
        var legacyHasStock = el.getAttribute('data-stock') === 'true';
        if (legacyHasStock) {
          stockDB = 1;
        } else if (isAvailable) {
          stockNOD = 1;
        }
      }

      // Flow-decision
      if (!isAvailable && stockDB === 0 && stockNOD === 0) {
        textEl.innerText = ltTekst('uit') || 'Tijdelijk uitverkocht';
        el.style.color = '#d32f2f';
      } else if (stockDB > 0) {
        // Den Bosch flow — zelfde pickup/leverdag-model als de PDP
        // (pws-delivery-countdown.js), zodat kaart en productpagina altijd
        // dezelfde bezorgdatum tonen.
        el.style.color = '#2e7d32';
        var grens = grensVoor(el);
        var cutoff = new Date(nowNL);
        cutoff.setHours(grens[0], grens[1], 0, 0);
        var beforeCutoff = isPickupDay(nowNL) && nowNL < cutoff;
        var dlv;
        if (beforeCutoff) {
          dlv = nextDayWhere(nowNL, isWorkDay);
        } else {
          // Cutoff gemist of geen pickup-dag (za/zo/feestdag): pakket gaat
          // mee op de volgende pickup-dag, bezorgd op de leverdag daarna.
          var pickup = nextDayWhere(nowNL, isPickupDay);
          dlv = nextDayWhere(pickup, isWorkDay);
        }
        var todayMid = new Date(nowNL.getFullYear(), nowNL.getMonth(), nowNL.getDate());
        var dlvMid = new Date(dlv.getFullYear(), dlv.getMonth(), dlv.getDate());
        var isTomorrow = Math.round((dlvMid - todayMid) / 86400000) === 1;
        if (beforeCutoff && isTomorrow) {
          textEl.innerText = ltTekst('morgen') || 'Morgen in huis';
          if (countdownEl) {
            countdownEl.dataset.active = 'true';
            countdownEl.dataset.cutoffH = String(grens[0]);
            countdownEl.dataset.cutoffM = String(grens[1]);
            hasActiveCountdown = true;
          }
        } else {
          textEl.innerText = ltTekst('op', dlv) || (dayNames[dlv.getDay()] + ' ' + fmtNL(dlv) + ' bezorgd');
          if (countdownEl) countdownEl.style.display = 'none';
        }
      } else if (stockNOD > 0 || isAvailable) {
        // NOD / backorder flow: handling-override of default leadtime
        el.style.color = '#2e7d32';
        var leadDays = handlingOverride > 0 ? handlingOverride : NOD_DEFAULT_LEAD_DAYS;
        var dlv2 = addWorkDays(nowNL, leadDays);
        textEl.innerText = ltTekst('uiterlijk', dlv2) || ('Uiterlijk ' + dayNames[dlv2.getDay()].toLowerCase() + ' ' + fmtNL(dlv2) + ' bezorgd');
        if (countdownEl) countdownEl.style.display = 'none';
      } else {
        textEl.innerText = ltTekst('uit') || 'Tijdelijk uitverkocht';
        el.style.color = '#d32f2f';
      }

      el.classList.add('processed');
    });

    if (hasActiveCountdown) startCountdown();
  }

  window.pwCalculateDeliveryDates = calculate;

  document.addEventListener('DOMContentLoaded', calculate);
  document.addEventListener('shopify:section:load', function () {
    clearCountdown();
    document.querySelectorAll('.pw-levertijd-wrapper.processed').forEach(function (el) {
      el.classList.remove('processed');
    });
    calculate();
  });
  calculate();
})();
